export default __webpack_public_path__ + "static/consulting-ac349ee13680ed6ad0aaabdbcd907264.jpg";